export var contentWrapper = 'rounded-10 flex flex-row items-center px-4 py-4 sm:px-6 justify-between';
export var contentWrapperChildList = 'rounded-10 bg-uiBg flex flex-row items-center px-4 py-4 sm:px-6 justify-between gap-4';
('rounded-10 flex flex-row items-center px-4 py-4 sm:px-6 justify-between');
export var menuItemIconContainer = 'flex-shrink-0 h-12  w-12 rounded-full flex justify-center items-center ';
export var menuItemIconContainerDefault = 'bg-primary text-white';
export var menuItemIcon = 'flex-shrink-0 h-6 w-6 ';
export var menuTitle = 'font-medium truncate';
export var menuSubItem = 'truncate mr-6 font-medium text-base';
export var menuSubTitle = 'mt-0 flex items-center text-sm';
export var menuChevron = 'h-6 w-6 text-primary';
export var menulistItemContainer = 'hover:bg-uiLight cursor-pointer';
//# sourceMappingURL=menu-list-item.styles.js.map